import React, { useEffect, useState } from 'react'
import { Button, Col, DatePicker, Form, Input, Row, Select, Space, Table, Upload } from 'antd';
import systemConfig from '../../../../config/systematic';
import antMessage from '../../../../utils/extend/AntdNotification'
import fetchApi from '../../../../utils/api/fetchApi';
import systemExpand from '../../../../config/systemExpand';
import FilesManage from '../../../filesSystem/FilesManage';

export default function HandleSignature() {
    /** 后端数据wmService */
    let wmService: any = systemConfig.wmService;
    const [form] = Form.useForm();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [imageUrl, setImageUrl] = useState<string>();

    const uploadButton = (
        <div>

            <div style={{ marginTop: 8 }}>系统文件</div>
        </div>
    );
    const [bb, setBa] = useState<any>();

    // const 
    const onFinish = () => {
        setIsLoading(true)
        form.validateFields()
            .then(async (values: any) => {
                fetchApi.GET(wmService, {
                    apiId: "handleSignature",
                    apiExtend: 'handleUserLicenseExpand',
                    apiData: values
                }).then((res) => {
                    setIsLoading(false)
                })
            }).catch((err: any) => {
                setIsLoading(false)

                console.log("err", err);
                antMessage('error', '发送失败', err.message + ' | status：' + err.errors.status);
            })
    }
    const getTempRoomTimeToCustomerReserve = () => {
        fetchApi.GET(wmService, {
            apiId: "customerReserve",
            apiExtend: 'getTempRoomTimeToCustomerReserve',
        }).then((res) => {
            antMessage('success', '成功');
            console.log("res", res);

        }).catch((err) => {
            console.log("err", err);
            antMessage('error', '失败', err.message + ' | status：' + err.errors.status);
        })

    }
    const getReserveTempRoomTimeToCustomerReserve = () => {
        fetchApi.GET(wmService, {
            apiId: "customerReserve",
            apiExtend: 'getReserveTempRoomTimeToCustomerReserve',
        }).then((res) => {
            antMessage('success', '成功');
            console.log("res", res);

        }).catch((err) => {
            console.log("err", err);
            antMessage('error', '失败', err.message + ' | status：' + err.errors.status);
        })

    }

    const bbb = () => {
        fetchApi.POST(wmService, {
            apiId: "cateringOrder",
            apiExtend: 'bbb',
            apiData: {
            }
        }).then((res) => {
            antMessage('success', '成功');
            console.log("res", res);

        }).catch((err) => {
            console.log("err", err);
            antMessage('error', '失败', err.message + ' | status：' + err.errors.status);
        })
    }
    const reset = () => {
        fetchApi.POST(wmService, {
            apiId: "invitationLetter",
            apiExtend: 'reset',
            apiData: {
            }
        }).then((res) => {
            antMessage('success', '成功');
            console.log("res", res);

        }).catch((err) => {
            console.log("err", err);
            antMessage('error', '失败', err.message + ' | status：' + err.errors.status);
        })
    }
    const ddd = () => {
        fetchApi.POST(wmService, {
            apiId: "queuingList",
            apiExtend: 'ddd',
            apiData: {
            }
        }).then((res) => {
            antMessage('success', '成功');
            console.log("res", res);

        }).catch((err) => {
            console.log("err", err);
            antMessage('error', '失败', err.message + ' | status：' + err.errors.status);
        })
    }
        const returnBackData = (data: any) => {

        form.setFieldValue("geSealObj", data.data)

    }
        useEffect(() => {
            
            const fetchData = async () => {
                let data = await systemExpand.filesServer2();
    
    
                const { apiServiceUrl, serviceId } = data;
    
                let uploadData = await FilesManage.upload(apiServiceUrl!, serviceId!, "appAutoUpdate", { successCallback: returnBackData })
                setBa(uploadData)
               
    
            }
            fetchData()
        }, [])
    const reconstruction = () => {
        fetchApi.POST(wmService, {
            apiId: "accountant",
            apiExtend: 'reconstruction',
            apiData: {
            }
        }).then((res) => {
            antMessage('success', '成功');
            console.log("res", res);

        }).catch((err) => {
            console.log("err", err);
            antMessage('error', '失败', err.message + ' | status：' + err.errors.status);
        })
    }
    return (
        <>
            <Form
                form={form}
                onFinish={onFinish}
            >
                <Row>
                    <Col span={10}>
                        <Form.Item
                            label="需要删除的字段"
                            name="deleteStr"
                            rules={[{ required: true, message: '请输入字段!' }]}
                        >
                            <Input
                            // onChange={handleChange}
                            // onBlur={handleBlur}
                            // placeholder="Input a number"
                            />
                        </Form.Item>
                    </Col>

                    <Col span={10}>
                        <Form.Item
                            label="需要替换的字段"
                            name="replaceStr"
                            rules={[{ required: true, message: '请输入字段!' }]}
                        >
                            <Input
                            // onChange={handleChange}
                            // onBlur={handleBlur}
                            // placeholder="Input a number"
                            />
                        </Form.Item>
                    </Col>
                    <Form.Item
                        label=""
                        name="geSealObj"

                    >
                        <Upload
                            maxCount={1}
                            {...bb}
                            listType="picture-card"
                        >
                            {imageUrl ? <img width={"100%"} src={imageUrl} alt="avatar" /> : uploadButton}
                        </Upload>
                    </Form.Item>
                    {/* <Col span={6}>
                        <Form.Item
                            label="删除的签名表"
                            name="signatures"
                        >
                            <Select
                                mode="multiple"
                                showSearch
                                placeholder="删除的签名表"
                                optionFilterProp="children"
                                onSearch={(e) => getList.search('dept', setDeptData, e)}
                                filterOption={(input:any, option: any) => {
                                    return true
                                }}
                            >
                                {getList.general(buyerData, 'buyerName')}
                            </Select>
                        </Form.Item>
                    </Col> */}





                    <Col span={4}>
                        <Form.Item >
                            <Space>
                                <Button loading={isLoading} htmlType="submit">
                                    发送
                                </Button >

                                {/* purContrast */}
                            </Space>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
            <Button onClick={getTempRoomTimeToCustomerReserve} danger>预订信息处理</Button>

            <Button onClick={getReserveTempRoomTimeToCustomerReserve} danger>预留房间预订信息处理</Button>


            <Button onClick={bbb} danger>备份点餐数据</Button>

            <Button onClick={reset} danger>重置邀请函信息</Button>

            <Button onClick={ddd} danger>备份排队数据</Button>

            <Button onClick={reconstruction} danger>重构历史表数据</Button>



        </>
    )
}
